(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acerstore-oferta-flash"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('acerstore-flash-offer')) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pad(n) { return String(n).padStart(2, '0'); }

    class AcerstoreFlashOffer extends HTMLElement {
      connectedCallback() {
        this.designMode = this.hasAttribute('data-design-mode');
        this.timer = this.querySelector('[data-timer]');
        this.hoursMode = this.dataset.hoursMode;
        this.expiredAction = this.dataset.expiredAction;
        this.startMs = this.parseDate(this.dataset.startDate, this.dataset.startTime, '00:00');
        this.endMs = this.parseDate(this.dataset.endDate, this.dataset.endTime, '23:59');

        if (this.timer) {
          this.units = {
            days: this.timer.querySelector('[data-unit="days"]'),
            hours: this.timer.querySelector('[data-unit="hours"]'),
            minutes: this.timer.querySelector('[data-unit="minutes"]'),
            seconds: this.timer.querySelector('[data-unit="seconds"]')
          };
        }

        this.tick = this.tick.bind(this);
        this.tick();
        if (!isNaN(this.startMs) || !isNaN(this.endMs)) {
          this.interval = setInterval(this.tick, 1000);
        }

        this.initCarousel();
        this.initVideos();
      }

      disconnectedCallback() {
        clearInterval(this.interval);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      /* "2026-10-05" + "23:59" + "-03:00" -> ms. Sin offset válido, usa la hora local del visitante. */
      parseDate(date, time, fallback) {
        date = (date || '').trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return NaN;
        time = (time || '').trim();
        if (!/^\d{1,2}:\d{2}$/.test(time)) time = fallback;
        if (time.length === 4) time = '0' + time;
        var offset = (this.dataset.utcOffset || '').trim();
        if (!/^[+-]\d{2}:\d{2}$/.test(offset)) offset = '';
        return new Date(date + 'T' + time + ':00' + offset).getTime();
      }

      tick() {
        var now = Date.now();

        /* Terminó */
        if (!isNaN(this.endMs) && now >= this.endMs) {
          this.render(0);
          clearInterval(this.interval);
          if (this.designMode) return;
          if (this.expiredAction === 'hide_section') this.hidden = true;
          else if (this.expiredAction === 'hide_timer' && this.timer) this.timer.hidden = true;
          return;
        }

        /* Aún no comienza: la sección queda oculta y aparece sola al llegar la hora */
        if (!this.designMode && !isNaN(this.startMs) && now < this.startMs) {
          this.hidden = true;
          return;
        }
        if (this.hidden) {
          this.hidden = false;
          this.updateNav();
        }

        if (!isNaN(this.endMs)) this.render(Math.floor((this.endMs - now) / 1000));
      }

      render(totalSec) {
        if (!this.timer) return;
        totalSec = Math.max(0, totalSec);
        var u = this.units;
        var hours;
        if (u.days) {
          this.set(u.days, pad(Math.floor(totalSec / 86400)));
          hours = Math.floor((totalSec % 86400) / 3600);
        } else {
          hours = Math.floor(totalSec / 3600); /* horas acumuladas, ej: 36 */
        }
        this.set(u.hours, pad(hours));
        this.set(u.minutes, pad(Math.floor((totalSec % 3600) / 60)));
        this.set(u.seconds, pad(totalSec % 60));
        this.timer.classList.toggle('is-urgent', totalSec > 0 && totalSec < 3600);
      }

      set(el, value) {
        if (el && el.textContent !== value) el.textContent = value;
      }

      /* ---------- Carrusel ---------- */
      initCarousel() {
        this.products = this.querySelector('[data-products]');
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');

        var self = this;
        if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.step(-1); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.step(1); });

        if (this.dotsWrap) {
          this.dotsWrap.innerHTML = '';
          this.dots = this.slides.map(function (slide, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'rfo-dots__btn';
            dot.setAttribute('aria-label', 'Ir a elemento ' + (i + 1));
            dot.addEventListener('click', function () {
              self.track.scrollTo({ left: slide.offsetLeft - self.slides[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
            });
            self.dotsWrap.appendChild(dot);
            return dot;
          });
        }

        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { self.updateNav(); ticking = false; });
        }, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(function () { self.updateNav(); });
          this.resizeObserver.observe(this.track);
        }
        this.updateNav();
      }

      stepSize() {
        var first = this.slides[0];
        if (!first) return this.track.clientWidth;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      step(dir) {
        this.track.scrollBy({ left: dir * this.stepSize(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateNav() {
        if (!this.track || !this.products) return;
        var max = this.track.scrollWidth - this.track.clientWidth;
        var x = this.track.scrollLeft;
        this.products.toggleAttribute('data-overflow', max > 2);
        if (this.prevBtn) this.prevBtn.disabled = x <= 2;
        if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;

        if (this.dots && this.dots.length) {
          var index = x >= max - 2 ? this.dots.length - 1 : Math.round(x / this.stepSize());
          index = Math.min(Math.max(index, 0), this.dots.length - 1);
          this.dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
            if (i === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }

      /* ---------- Video con portada ---------- */
      initVideos() {
        this.querySelectorAll('[data-play]').forEach(function (btn) {
          btn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            var poster = btn.closest('[data-poster]');
            var video = poster && poster.parentElement.querySelector('video');
            if (!video) return;
            poster.hidden = true;
            video.controls = true;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          });
        });
      }
    }

    customElements.define('acerstore-flash-offer', AcerstoreFlashOffer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class PivotCollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.ACTIVE_CLASS = 'pivot-collection-tabs__active';
      this.ACTIVE_TAB_CLASS = 'pivot-collection-tabs__tab--active';
      this.tabs = [...this.querySelectorAll('.pivot-collection-tabs__tab')];
      this.isButtonsStyle = this.classList.contains('pivot-menu-buttons');
    }
    connectedCallback() {
      if (!this.isConnected) return;
      this.tabs.forEach((btn) =>
        btn.addEventListener('click', (e) => {
          const currentTab = this.querySelector(`.pivot-collection-tabs__tab.${this.ACTIVE_TAB_CLASS}`);
          const newTab = e.target.closest('button');
          const currentSection = this.querySelector(`.pivot-collection-tabs__collection-carousel.${this.ACTIVE_CLASS}`);
          const newActiveSection = this.querySelector(
            `.pivot-collection-tabs__collection-carousel#${newTab.dataset.tab}`
          );
          if (currentSection) currentSection.classList.remove(this.ACTIVE_CLASS);
          if (currentTab) {
            currentTab.classList.remove(this.ACTIVE_TAB_CLASS);
            if (this.isButtonsStyle) currentTab.classList.add('button--secondary');
          }
          if (newActiveSection) newActiveSection.classList.add(this.ACTIVE_CLASS);
          if (newTab) {
            newTab.classList.add(this.ACTIVE_TAB_CLASS);
            if (this.isButtonsStyle) newTab.classList.remove('button--secondary');
          }
        })
      );
    }
  }
  if (!customElements.get('pivot-collection-tabs')) {
    customElements.define('pivot-collection-tabs', PivotCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-product-description"] && !Shopify.designMode) return;
  try {
    
  class PivotProductDescription extends HTMLElement {
    constructor() {
      super();
      this.$triggersWrapper = this.querySelector('.pivot-product-description__tabs');
      this.$$triggers = this.$triggersWrapper.querySelectorAll('button');
      this.$contentsWrapper = this.querySelector('.pivot-product-description__contents');

      this.$$triggers.forEach((button) => {
        button.addEventListener('click', (e) => {
          const currentActive = this.$triggersWrapper.querySelector('button.active');
          if (currentActive) currentActive.classList.remove('active');
          button.classList.add('active');

          const currentSectionActive = this.$contentsWrapper.querySelector('div.active');
          if (currentSectionActive) currentSectionActive.classList.remove('active');

          const selector = `div[data-link="${button.dataset.link}"]`;
          const newSectionActive = this.$contentsWrapper.querySelector(selector);
          console.log(selector, newSectionActive);
          if (newSectionActive) newSectionActive.classList.add('active');
        });
      });
    }
  }
  if (!customElements.get('pivot-product-description')) {
    customElements.define('pivot-product-description', PivotProductDescription);
  }

  class PivotJsonTable extends HTMLElement {
    constructor() {
      super();
      const data = JSON.parse(this.textContent);
      console.log(data);
      let code = `<table>
        ${Object.entries(data).reduce((acc, [k, v]) => {
          return `${acc} 
          <tr>
            <td>${k}</td>
            <td>${v}</td>
          </tr>`;
        }, '')}
        </table>`;
      this.innerHTML = code;
    }
  }
  if (!customElements.get('pivot-json-table')) {
    customElements.define('pivot-json-table', PivotJsonTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-product-details"] && !Shopify.designMode) return;
  try {
    
  class PivotProductDescription extends HTMLElement {
    constructor() {
      super();
      this.$triggersWrapper = this.querySelector('.pivot-product-description__tabs');
      this.$$triggers = this.$triggersWrapper.querySelectorAll('button');
      this.$contentsWrapper = this.querySelector('.pivot-product-description__contents');

      this.$$triggers.forEach((button) => {
        button.addEventListener('click', (e) => {
          const currentActive = this.$triggersWrapper.querySelector('button.active');
          if (currentActive) currentActive.classList.remove('active');
          button.classList.add('active');

          const currentSectionActive = this.$contentsWrapper.querySelector('details[open]');
          if (currentSectionActive) currentSectionActive.open = false;

          const selector = `details[data-link="${button.dataset.link}"]`;
          const newSectionActive = this.$contentsWrapper.querySelector(selector);
          if (newSectionActive) newSectionActive.open = true;
        });
      });

      // Respaldo: si no hay descripción ni especificaciones, abrir la primera pestaña disponible
      if (!this.$triggersWrapper.querySelector('button.active') && this.$$triggers.length) {
        this.$$triggers[0].click();
      }
    }
  }
  if (!customElements.get('pivot-product-description')) {
    customElements.define('pivot-product-description', PivotProductDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-store-attributes"] && !Shopify.designMode) return;
  try {
    
  class PivotStoreAttributes extends HTMLElement {
    constructor() {
      super();
      this.dkColumns = Number(this.getAttribute('dk-columns') || 1);
      this.mbColumns = Number(this.getAttribute('mb-columns') || 1);
      this.dkCarousel = this.getAttribute('dk-carousel') === 'true';
      this.mbCarousel = this.getAttribute('mb-carousel') === 'true';
      this.dkArrows = this.getAttribute('dk-arrows') === 'true';
      this.mbArrows = this.getAttribute('mb-arrows') === 'true';
      this.enableDivider = this.getAttribute('enable-divider') === 'true';
      this.paginationColorScheme = this.dataset.paginationColorScheme;
    }
    async connectedCallback() {
      if (!this.isConnected) return;
      await import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js');
      const config = {
        perPage: this.dkColumns,
        gap: this.enableDivider ? '2rem' : '4rem',
        destroy: !this.dkCarousel,
        arrows: this.dkArrows,
        breakpoints: {
          750: {
            perPage: this.mbColumns,
            gap: this.enableDivider ? '1rem' : '2rem',
            destroy: !this.mbCarousel,
            arrows: this.mbArrows,
          },
        },
      };

      console.log('Config', config);

      this.splide = new Splide(this.querySelector('.splide'), config);
      this.splide.on('mounted', () => {
        const pagination = this.querySelector('.splide__pagination');
        pagination.classList.add(`color-${this.paginationColorScheme}`);
      });
      this.splide.mount();
    }
  }
  if (!customElements.get('pivot-store-attributes')) {
    customElements.define('pivot-store-attributes', PivotStoreAttributes);
  }

  } catch(e) { console.error(e); }
})();
})();
